// FIELD RULES
export const FIELD_RULES = {
  ASYNC: 'ASYNC',
  ALPHABETICAL: 'ALPHABETICAL',
  ALPHANUMERIC: 'ALPHANUMERIC',
  EMAIL: 'EMAIL',
  EQUAL: 'EQUAL',
  INCLUDES_LETTER: 'INCLUDES_LETTER',
  INCLUDES_NUMBER: 'INCLUDES_NUMBER',
  INCLUDES_SYMBOL: 'INCLUDES_SYMBOL',
  LATIN: 'LATIN',
  MAX: 'MAX',
  MAX_AGE: 'MAX_AGE',
  MAX_LENGTH: 'MAX_LENGTH',
  MIN: 'MIN',
  MIN_AGE: 'MIN_AGE',
  MIN_LENGTH: 'MIN_LENGTH',
  NUMERIC: 'NUMERIC',
  PHONE: 'PHONE',
  REQUIRED: 'REQUIRED',
  UNIQUE: 'UNIQUE'
}

// RULE BEHAVIORS
export const RULE_BEHAVIORS = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  DISABLED: 'DISABLED'
}

export const FIELD_COMPONENTS = {
  CHECKBOX: 'CHECKBOX',
  COMPLEX_PASSWORD: 'COMPLEX_PASSWORD',
  CURRENCYPICKER: 'CURRENCYPICKER',
  EMAIL_WITH_VERIFICATION: 'EMAIL_WITH_VERIFICATION',
  FILE: 'FILE',
  LIST: 'LIST',
  NUMBER: 'NUMBER',
  PASSWORD: 'PASSWORD',
  PHONE: 'PHONE',
  PHONE_WITH_VERIFICATION: 'PHONE_WITH_VERIFICATION',
  RADIO_BUTTON: 'RADIO_BUTTON',
  SELECT: 'SELECT',
  STRING: 'STRING',
  TEXT: 'TEXT',
  TIMESTAMP: 'TIMESTAMP',
  SMS_CODE: 'SMS_CODE',
  ADDRESS_AUTOCOMPLETE: 'ADDRESS_AUTOCOMPLETE',
  HOW_DID_YOU_HEAR_ABOUT_US: 'HOW_DID_YOU_HEAR_ABOUT_US'
}

export const FIELD_RULE_TYPES = FIELD_RULES
export const RULE_TYPES = FIELD_RULES

export const PAYMENT_METHODS_OPERATION_TYPE_DEPOSIT = 'DEPOSIT'
export const PAYMENT_METHODS_OPERATION_TYPE_WITHDRAWAL = 'WITHDRAWAL'
export const PAYMENT_PROCESSING_TYPE_REDIRECT = 'REDIRECT'

export const DEPOSIT_PROCESSING_TYPE = {
  NONE: 'NONE',
  POPUP: 'POPUP',
  REDIRECT: 'REDIRECT',
  FORM_POST: 'FORM_POST',
  EFT: 'EFT',
  PAYID: 'PAYID'
}

export const WITHDRAWAL_PROCESSING_TYPE = {
  NONE: 'NONE',
  POPUP: 'POPUP',
  REDIRECT: 'REDIRECT',
  EFT: 'EFT',
  PAYID: 'PAYID'
}
